<div class="flex flex-col gap-1">
  <div class="flex items-center gap-1">
    <div class="flex items-center gap-0.5">
      <mat-icon
        color="primary"
        fontIcon="add_circle_outline"
        class="material-symbols-outlined qaroni-mat-icon-14" />

      <strong class="text-base">{{ value() | number }}</strong>
    </div>

    <span class="text-neutral-50">
      <ng-container i18n>de</ng-container>
      {{ total() | number }}
    </span>
  </div>

  <mat-progress-bar
    mode="determinate"
    class="bg-neutral-90"
    [value]="percentage" />
</div>
